/**
 * @public
 */
const IControllerService = Symbol('service:controller');

export { IControllerService };
//# sourceMappingURL=controller-service.interface.js.map
